<template>
  <div>
    <div class="search flex-box bb">
      <label for="searchUser" class="flex2 flex-box flex-v-c" :class="{br:searchUserId}">
        <input
          id="searchUser"
          class="searchUser"
          type="number"
          @input="inputNull"
          placeholder="输入玩家ID查询"
          v-model="searchUserId"
        >
        <div class="closeBtn" v-show="searchUserId" @click="clear"></div>
      </label>
      <div class="flex1 flex-box flex-hv-c" @click="search" v-show="searchUserId">
        <div class="button">
          搜索
          <i class="iconfont icon-search"></i>
        </div>
      </div>
    </div>

    <div class="info">
      <ul>
        <div class="flex-box flex-hv-c">
          <img class="avatar" :src="data.headimgurl" alt>
        </div>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">游戏ID：{{data.userId}}</span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">昵称：{{data.nickname}}</span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">代理等级：{{data.level}}</span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">最后游戏时间：{{data.lastGameTime}}</span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">
            该玩家所绑定的代理：{{data.bindMemberNickname}}-
            <span class="tip">{{data.userMember}}</span>
          </span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">
            所属商务：{{data.realname}}-
            <span class="tip">{{data.managerId}}</span>
          </span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">所属负责人：{{data.partnerName}}</span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">是否为僵尸玩家：{{data.isZombie?'是':'不是'}}</span>
        </li>

        <div class="button setToggleBtn" v-if="data" @click="check">{{buttonTxt}}</div>
        <div
          class="button toggleWeiXin"
          v-if="data.managerId==userManagerId && data.level != '不是代理'"
          @click="toggleWeiXin"
        >申请切换登录微信号</div>
      </ul>
    </div>
  </div>
</template>
<!--javascript-->
<script>
export default {
  data: function () {
    return {
      data: '',
      searchUserId: '',
      toggleId: '',
      alertMsg: '',
      buttonTxt: '申请解绑',
      flag: false,
      userManagerId: localStorage.getItem('managerId')
    }
  },
  methods: {
    toggleWeiXin() {
      var that = this
      this.$messagebox.prompt('请提供该代理新微信的游戏ID(新ID不能是代理)', '提示').then(({ value, option }) => {
        if (!value) {
          this.$toast('请输入游戏ID')
          return
        }
        this.$messagebox.confirm('是否确认将代理游戏ID：<span class="tip">' + that.data.userId + '</span> 切换到 <span class="tip">' + value + '</span>上？', '提示').then((option) => {
          this.$http.post('/player/switchWeChat', { oldId: that.data.userId, newId: value, }).then((res) => {
            if (res.code == 0) {
              this.$toast('已提交，请您联系客服审核，审核通过后重新登录游戏生效')
            } else {
              this.$toast(res.message)
            }
          })
        })
      })
    },
    check() {

      if (this.data.level != '预备代理' && this.data.level != '不是代理') {
        this.$toast('该代理申请解绑请联系客服')
        this.buttonTxt = '该代理申请解绑请联系客服'
        this.flag = false
      } else {//预备代理或玩家
        if (this.data.isZombie == 1) {
          this.buttonTxt = '申请解绑'
          this.alertMsg = '确认解绑该僵尸玩家？'
          this.flag = true
          this.req()
        } else {
          if (this.data.managerId == localStorage.getItem('managerId')) {
            this.buttonTxt = '申请解绑'
            this.alertMsg = '该玩家为活跃玩家，是否确认解绑'
            this.flag = true
            this.req()
          } else {
            this.flag = false
            this.$toast('不符合解绑条件，活跃玩家解绑请联系所属商务')
          }
        }
      }
    },
    req() {
      var that = this
      if (that.flag) {
        this.$messagebox.confirm(this.alertMsg, '提示').then((option) => {
          this.$http.post('/player/unBindMember', { userId: this.searchUserId }).then((res) => {
            if (res.code == 0) {
              this.$toast(res.message)
            } else {
              this.$toast(res.message)
            }
          })
        })
      }
    },
    search() {
      this.$http.get('/player/Info', { params: { userId: this.searchUserId } }).then((res) => {
        if (res.code == 0) {
          this.data = res.data
          if (!this.data.userMember) {
            this.buttonTxt = '该玩家还没绑定代理，无需解绑'
            this.flag = false
          }
        } else {
          this.$toast(res.message)
        }
      })
    },
    inputNull() {
      this.data = ''
      this.buttonTxt = '申请解绑'
    },
    clear() {
      this.searchUserId = ''
      this.data = ''
    }
  },
  mounted: function () {
  },
  created: function () {
  }
}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
.search {
  height: 1rem;
}

.searchUser {
  width: 100%;
  padding-left: 10px;
  text-align: center;
}

.info ul {
  padding: 0 0.5rem;
  margin-top: 0.5rem;
  li {
    height: 0.7rem;
  }
}

.avatar {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  -webkit-box-shadow: 5px 4px 6px #ddd;
  box-shadow: 5px 4px 6px #ddd;
}

.setToggleBtn,
.toggleWeiXin {
  margin-top: 0.3rem;
  height: 0.7rem;
}
.info {
  height: calc(100vh - 2rem);
  -webkit-overflow-scrolling: touch;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/toggle/index.vue